import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { FluentProvider } from "@fluentui/react-components";
import { fearnleysLightTheme } from "./config/theme";

/* global document, Office, module, require */

let isOfficeInitialized = false;

const title = "Salmon Forward Pricing";

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <FluentProvider theme={fearnleysLightTheme}>
        <Component title={title} isOfficeInitialized={isOfficeInitialized} />
      </FluentProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
